import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

// Handles Emergent Google Auth callback. Mounted whenever the URL hash
// contains `#session_id=...`. Exchanges the session_id with our backend,
// establishes the cookie session, then redirects into the app.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : null;

    (async () => {
      if (!sessionId) {
        navigate("/advertise", { replace: true });
        return;
      }
      try {
        await api.post("/auth/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        await refresh();
        // Clear the hash and route into the customer dashboard
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/my-campaigns", { replace: true });
      } catch (err) {
        toast.error("Sign-in failed. Please try again.");
        navigate("/advertise", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-[40vh] flex flex-col items-center justify-center gap-3" data-testid="auth-callback">
      <Loader2 className="animate-spin" size={28} />
      <p className="text-sm font-mono text-zinc-600">Finishing sign-in…</p>
    </div>
  );
}
